// 🌐 Base URLs
export const API_BASE_URL = 'https://fothubtvapi.fothubtv.com/api';
export const IMAGE_BASE_URL = 'https://fothubtvapi.fothubtv.com';
// export const API_BASE_URL = 'http://127.0.0.1:8000/api';
// export const IMAGE_BASE_URL = 'http://127.0.0.1:8000';

// 📡 API Endpoints
export const ENDPOINT = {
    // =====================================================
    // 🧍‍♀️ Authentication & Profile
    // =====================================================
    REGISTER: `${API_BASE_URL}/register/`,
    LOGIN: `${API_BASE_URL}/login/`,
    PROFILE: `${API_BASE_URL}/profile/`,

    // =====================================================
    // 👥 USER MANAGEMENT (Admin or Staff)
    // =====================================================
    USER_LIST: `${API_BASE_URL}/users/`, // GET
    USER_DETAIL: (userId) => `${API_BASE_URL}/users/${userId}/`, // GET detail
    USER_UPDATE: (userId) => `${API_BASE_URL}/users/${userId}/update/`, // PUT/PATCH
    USER_DELETE: (userId) => `${API_BASE_URL}/users/${userId}/delete/`, // DELETE

    // =====================================================
    // 🧩 GROUP MANAGEMENT (Admin)
    // =====================================================
    GROUP_LIST: `${API_BASE_URL}/groups/`, // GET
    GROUP_CREATE: `${API_BASE_URL}/groups/create/`, // POST
    GROUP_DETAIL: (groupId) => `${API_BASE_URL}/groups/${groupId}/`, // GET detail
    GROUP_UPDATE: (groupId) => `${API_BASE_URL}/groups/${groupId}/update/`, // PUT/PATCH
    GROUP_DELETE: (groupId) => `${API_BASE_URL}/groups/${groupId}/delete/`, // DELETE

    // =====================================================
    // 🔐 PERMISSIONS LIST
    // =====================================================
    PERMISSION_LIST: `${API_BASE_URL}/permissions/`, // GET

    // =====================================================
    // 🔑 PASSWORD RESET (Public)
    // =====================================================
    PASSWORD_FORGOT: `${API_BASE_URL}/password/forgot/`, // POST
    PASSWORD_RESET: `${API_BASE_URL}/password/reset/`, // POST

    BANNER_LIST: `${API_BASE_URL}/banner/`,
    BANNER_CREATE: `${API_BASE_URL}/banner/create/`,
    BANNER_DETAIL: (bannerId) => `${API_BASE_URL}/banner/${bannerId}/`,
    BANNER_UPDATE: (bannerId) => `${API_BASE_URL}/banner/update/${bannerId}/`,
    BANNER_DELETE: (bannerId) => `${API_BASE_URL}/banner/delete/${bannerId}/`,

    LEAGUECATEGORY_LIST: `${API_BASE_URL}/league-category/`,
    LEAGUECATEGORY_CREATE: `${API_BASE_URL}/league-category/create/`,
    LEAGUECATEGORY_DETAIL: (leaguecategoryId) => `${API_BASE_URL}/league-category/${leaguecategoryId}/`,
    LEAGUECATEGORY_UPDATE: (leaguecategoryId) => `${API_BASE_URL}/league-category/update/${leaguecategoryId}/`,
    LEAGUECATEGORY_DELETE: (leaguecategoryId) => `${API_BASE_URL}/league-category/delete/${leaguecategoryId}/`,

    TEAM_LIST: `${API_BASE_URL}/team/`,
    TEAM_CREATE: `${API_BASE_URL}/team/create/`,
    TEAM_DETAIL: (teamId) => `${API_BASE_URL}/team/${teamId}/`,
    TEAM_UPDATE: (teamId) => `${API_BASE_URL}/team/update/${teamId}/`,
    TEAM_DELETE: (teamId) => `${API_BASE_URL}/team/delete/${teamId}/`,

    LIVECATEGORY_LIST: `${API_BASE_URL}/live-category/`,
    LIVECATEGORY_CREATE: `${API_BASE_URL}/live-category/create/`,
    LIVECATEGORY_DETAIL: (livecategoryId) => `${API_BASE_URL}/live-category/${livecategoryId}/`,
    LIVECATEGORY_UPDATE: (livecategoryId) => `${API_BASE_URL}/live-category/update/${livecategoryId}/`,
    LIVECATEGORY_DELETE: (livecategoryId) => `${API_BASE_URL}/live-category/delete/${livecategoryId}/`,

    LIVE_LIST: `${API_BASE_URL}/live/`,
    LIVE_CREATE: `${API_BASE_URL}/live/create/`,
    LIVE_DETAIL: (liveId) => `${API_BASE_URL}/live/${liveId}/`,
    LIVE_UPDATE: (liveId) => `${API_BASE_URL}/live/update/${liveId}/`,
    LIVE_DELETE: (liveId) => `${API_BASE_URL}/live/delete/${liveId}/`,

    HIGHLIGHTCATEGORY_LIST: `${API_BASE_URL}/highlightcategory/`,
    HIGHLIGHTCATEGORY_CREATE: `${API_BASE_URL}/highlightcategory/create/`,
    HIGHLIGHTCATEGORY_DETAIL: (highlightcategoryId) => `${API_BASE_URL}/highlightcategory/${highlightcategoryId}/`,
    HIGHLIGHTCATEGORY_UPDATE: (highlightcategoryId) => `${API_BASE_URL}/highlightcategory/update/${highlightcategoryId}/`,
    HIGHLIGHTCATEGORY_DELETE: (highlightcategoryId) => `${API_BASE_URL}/highlightcategory/delete/${highlightcategoryId}/`,

    HIGHLIGHT_LIST: `${API_BASE_URL}/highlight/`,
    HIGHLIGHT_CREATE: `${API_BASE_URL}/highlight/create/`,
    HIGHLIGHT_DETAIL: (highlightId) => `${API_BASE_URL}/highlight/${highlightId}/`,
    HIGHLIGHT_UPDATE: (highlightId) => `${API_BASE_URL}/highlight/update/${highlightId}/`,
    HIGHLIGHT_DELETE: (highlightId) => `${API_BASE_URL}/highlight/delete/${highlightId}/`,

    TABLE_LIST: `${API_BASE_URL}/league-table/`,
    TABLE_CREATE: `${API_BASE_URL}/league-table/create/`,
    TABLE_DETAIL: (tableId) => `${API_BASE_URL}/league-table/${tableId}/`,
    TABLE_UPDATE: (tableId) => `${API_BASE_URL}/league-table/update/${tableId}/`,
    TABLE_DELETE: (tableId) => `${API_BASE_URL}/league-table/delete/${tableId}/`,

    TIP_LIST: `${API_BASE_URL}/tips-admin/`,
    TIP_CREATE: `${API_BASE_URL}/tips/create/`,
    TIP_DETAIL: (tipsId) => `${API_BASE_URL}/tips/${tipsId}/`,
    TIP_UPDATE: (tipsId) => `${API_BASE_URL}/tips/update/${tipsId}/`,
    TIP_DELETE: (tipsId) => `${API_BASE_URL}/tips/delete/${tipsId}/`,

    ODDS_LIST: `${API_BASE_URL}/odds-admin/`,
    ODDS_CREATE: `${API_BASE_URL}/odds/create/`,
    ODDS_DETAIL: (oddsId) => `${API_BASE_URL}/odds/${oddsId}/`,
    ODDS_UPDATE: (oddsId) => `${API_BASE_URL}/odds/update/${oddsId}/`,
    ODDS_DELETE: (oddsId) => `${API_BASE_URL}/odds/delete/${oddsId}/`,

   // 🔔 Firebase Cloud Messaging (FCM)
    FCM_DEVICE_LIST: `${API_BASE_URL}/fcm-device/`,             // ✅ GET all FCM tokens (Admin only)
    FCM_DEVICE_REGISTER: `${API_BASE_URL}/fcm-device/register/`, // ✅ POST token (User)
    FCM_BROADCAST_SEND: `${API_BASE_URL}/fcm-broadcast/send/`,   // ✅ POST broadcast from admin

    DASHBOARD: `${API_BASE_URL}/dashboard_stats/`,
};
